import React from 'react';
import { FiCheckCircle } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import truckIcon from '../../assets/truck.svg';
import { currencySymbol as currencySymbolUtil, shopAmount } from '../../utils/currency';
import { useCurrency } from '../../Context/CurrencyContext';
import styles from './styles.module.css';

const FreeShippingBar = ({
  threshold,
  cartTotal = 0,
  currencySymbol: currencySymbolProp,
  testId = 'free-shipping-bar',
}) => {
  const { t } = useTranslation();
  const ccy = useCurrency();
  const symbol = currencySymbolProp || currencySymbolUtil(ccy);
  if (!threshold || threshold <= 0) return null;

  const total = Math.max(0, Number(cartTotal) || 0);
  const remaining = Math.max(0, threshold - total);
  const pct = Math.min(100, Math.round((total / threshold) * 100));
  // Free only when nothing is left to add, to the agora — float dust from
  // `200 - 199.9` is not a gap, but 0.10 is.
  const unlocked = remaining < 0.005;

  // The gap as it is, never rounded: a basket 0.10 short read "₪0 more for free
  // shipping" while delivery was still charged (UX-FINAL-19). The same amount
  // and form as the shop hero's chip.
  const message = unlocked
    ? t('shop.freeShippingUnlocked', { defaultValue: 'You’ve unlocked free shipping!' })
    : t('shop.freeShippingRemaining', {
        defaultValue: '{{remaining}} more for free shipping',
        remaining: `${shopAmount(remaining, ccy)} ${symbol}`,
        currency: symbol,
      });

  return (
    <div className={styles.wrap} data-testid={testId}>
      <div className={styles.card}>
        <p className={styles.msg}>{message}</p>
        <div className={styles.trackRow}>
          <div className={styles.track}>
            <div
              className={styles.fill}
              style={{ width: `${pct}%` }}
              aria-hidden
            />
          </div>
          <div className={`${styles.iconChip} ${unlocked ? styles.iconChipActive : ''}`} aria-hidden>
            {unlocked
              ? <FiCheckCircle />
              : <img src={truckIcon} className={styles.truckImg} alt="" aria-hidden />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FreeShippingBar;
